import { EconomicsSettingsVariableAnnualInputBase } from './base/economics-settings-variable-annual-input-base';

export class EconomicsSettingsVariableAnnualInput extends EconomicsSettingsVariableAnnualInputBase { }